import { z } from 'zod';
import { CmsImageSchema, CmsRichTextSchema, CmsShortTextSchema } from '$cms/types';
import { makeContentComponentDefaultConfig } from '$util/makeContentComponentDefaultConfig';
import type { SchemaType } from '$util/schema';

export const defaultConfiguration = makeContentComponentDefaultConfig({
  sku: undefined,
});

export const CmsHeroSectionSchema = {
  translatedEntities: z.object({
    heading: z.union([CmsRichTextSchema, CmsShortTextSchema]),
    mainCta: CmsShortTextSchema.optional(),
    subheading: CmsShortTextSchema.optional(),
    grandLabel: CmsRichTextSchema.optional(),
    partOfRenaultText: CmsShortTextSchema.optional(),
    partOfRenaultLogo: CmsImageSchema.optional(),
  }),
  configuration: z
    .object({
      sku: z.string().optional(),
      preloadImages: z.boolean().optional(),
      lazyLoadImages: z.boolean().optional(),
    })
    .default(defaultConfiguration),
};

export type CmsHeroSectionTranslatedEntities = SchemaType<
  (typeof CmsHeroSectionSchema)['translatedEntities']
>;
export type CmsHeroSectionConfiguration = SchemaType<(typeof CmsHeroSectionSchema)['configuration']>;
